import { Tabs } from 'antd';
import styled from 'styled-components';

export const StyledTabs = styled(Tabs)<{ $compact?: boolean }>`
    --tab-width: 120px;

    .ant-tabs-nav .ant-tabs-nav-wrap {
        flex: 1 1 auto;
        ${({ $compact }) => $compact && 'justify-content: flex-start;'}
    }

    .ant-tabs-nav .ant-tabs-nav-list {
        width: ${({ $compact }) => ($compact ? 'auto' : '100%')};
        justify-content: ${({ $compact }) => ($compact ? 'flex-end' : 'space-between')};
        gap: ${({ $compact }) => ($compact ? '120px' : '0')};
    }

    .ant-tabs-tab {
        flex: 0 0 120px;
        width: var(--tab-width);
        margin: 0 !important;
        display: flex;
        text-align: left;
    }

    .ant-tabs-tab .ant-tabs-tab-btn {
        display: inline-block;
        width: 100%;
    }

    .ant-tabs-ink-bar {
        width: var(--tab-width) !important;
    }
`;
